import {del, get, post, put} from "../util/http.service";

export const apiGetContacts = params => ({
  queryKey: ["contacts", params],
  queryFn: () => get("/api/contacts", params),
  placeholderData: (previousData) => previousData
});

export const apiCreateContact = () => ({
  mutationFn: data => post("/api/contacts", data)
});

export const apiUpdateContact = id => ({
  mutationFn: data => put("/api/contacts/" + id, data)
});

export const apiDeleteContact = () => ({
  mutationFn: id => del("/api/contacts/" + id)
});
